module.exports = __webpack_public_path__ + "img/73a62e7.jpg";